"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.API_SCOPE_VALUES = exports.API_SCOPES = void 0;
exports.isApiScope = isApiScope;
exports.apiScope = apiScope;
exports.API_SCOPES = [
    {
        value: 'assets:read',
        label: 'Read assets',
        description: 'List and read vehicles — fleet number, plate, make, model, status.',
        group: 'Fleet',
        write: false,
    },
    {
        // Split out of the old catch-all `dispatch:read`. This is the narrow half:
        // one job, by an id the caller already has, which it can only have because
        // it created the job or was told the id. Enumeration needs `dispatch:list`.
        value: 'dispatch:read',
        label: 'Read one dispatch job',
        description: 'Read a single dispatch job by its AFM id (GET /dispatch-jobs/{id}). Does not allow listing.',
        group: 'Dispatch',
        write: false,
    },
    {
        // The broad half. Held separately because the list endpoint is a bulk
        // export: filters, paging and `updatedSince` over every job in the system,
        // not just the caller's own. Most partners never need it — they hold their
        // own `externalRef` and read jobs back one at a time.
        value: 'dispatch:list',
        label: 'List all dispatch jobs',
        description: 'Page through every dispatch job, including jobs raised by other partners and by Atlas staff '
            + '(GET /dispatch-jobs). Broad — grant only when the caller genuinely needs to sync the collection.',
        group: 'Dispatch',
        write: false,
    },
    {
        // Split out of the old `dispatch:write`, which granted both. Creating and
        // updating are different risks: a partner that only raises jobs never
        // needs to touch one AFM staff may have edited since, and a partner that
        // only reports status changes never needs to raise anything. Granting one
        // without the other is now expressible.
        value: 'dispatch:create',
        label: 'Create dispatch jobs',
        description: 'Raise new dispatch jobs, including their product lines. Cannot change an existing job.',
        group: 'Dispatch',
        write: true,
    },
    {
        value: 'dispatch:update',
        label: 'Update dispatch jobs',
        description: 'Change existing dispatch jobs — status, times, customer, product lines. Cannot raise new ones.',
        group: 'Dispatch',
        write: true,
    },
    {
        value: 'dispatch:delete',
        label: 'Delete dispatch jobs',
        description: 'Permanently delete a dispatch job and its product lines. Separate from write because it cannot be undone.',
        group: 'Dispatch',
        write: true,
    },
    {
        // Narrower than `dispatch:update`: a weighbridge reports what happened to
        // each load it weighed, and nothing else. It can't move times, change the
        // vehicle or rewrite lines, and can't set the job's own status — that is
        // rolled up from the lines.
        value: 'dispatch-lines:update',
        label: 'Update line item status',
        description: 'Set the status of a single product line (PUT /dispatch-job-lines/{id}). The job goes Complete once every weighbridge line is. Cannot change anything else.',
        group: 'Dispatch',
        write: true,
    },
    {
        // Previously gated on `dispatch:read`, on the reasoning that anyone who can
        // read jobs can read the codes those jobs reference. That conflated two
        // unrelated surfaces: the codes are needed to WRITE a job, so a create-only
        // partner had to be handed job-read access purely to look them up.
        value: 'catalogue:read',
        label: 'Read catalogue items',
        description: 'List the item codes accepted in a job\u2019s product lines (GET /catalogue-items). '
            + 'Codes, descriptions and units only — never prices.',
        group: 'Catalogue',
        write: false,
    },
];
exports.API_SCOPE_VALUES = exports.API_SCOPES.map((s) => s.value);
function isApiScope(value) {
    return exports.API_SCOPE_VALUES.includes(value);
}
function apiScope(value) {
    return exports.API_SCOPES.find((s) => s.value === value);
}
//# sourceMappingURL=api-scopes.js.map